<template>
  <div class="candidate">
    <a-radio-group v-model="statues" @change="getData()">
      <template v-for="item in radioData">
        <a-radio-button :value="item.value" :key="item.value">{{item.label}}</a-radio-button>
      </template>
    </a-radio-group>
    <div class="data-table" style="padding:30px 0;">
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
        :customRow="rowClick"
        :scroll="{ x: 1600, y: 900 }"
      >
        <template slot="hunter" slot-scope="name, record">
          <span>{{ name }}</span>
          <span class="badge" v-if="record.is_sign == 1">签</span>
        </template>
        <template slot="status" slot-scope="status">
          <span
            :class="{
              tag: true,
              blue:
                [
                  'CREATED',
                  'AUDIT_PASSED',
                  'AUDIT_FAILED',
                  'SUBMIT_FAILED'
                ].indexOf(status) > -1
            }"
            >推</span
          >
          <span
            :class="{
              tag: true,
              blue:
                [
                  'SUBMIT_PASSED',
                  'INTERVIEW',
                  'INTERVIEW_FAILED',
                  'CLOSED'
                ].indexOf(status) > -1
            }"
            >面</span
          >
          <span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }"
            >录</span
          >
          <span
            :class="{
              tag: true,
              blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1
            }"
            >职</span
          >
          <span
            :class="{
              tag: true,
              blue:
                ['COMPLETED', 'NOT_COMPLETED', 'UNSETTLED', 'SETTLED'].indexOf(
                  status
                ) > -1
            }"
            >保</span
          >
        </template>
        <template slot="action" slot-scope="{ status }, record">
          <div v-if="record.ie_user_id == $store.state.user.uid">
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'CREATED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('审核通过', record)"
                  >审核通过</a-button
                >
                <br />
                <a-button
                  type="link"
                  @click.stop="stopStep('审核不通过', record)"
                  >审核不通过</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'AUDIT_PASSED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('推荐通过', record)"
                  >推荐通过</a-button
                >
                <br />
                <a-button
                  type="link"
                  @click.stop="stopStep('推荐不通过', record)"
                  >推荐不通过</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'SUBMIT_PASSED'"
            >
              <a-col>
                <a-button
                  type="link"
                  @click.stop="$refs.arrangeInterviewModal.show(record)"
                  >安排面试</a-button
                >
                <br />
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                    <a-menu-item @click="stopStep('关闭订单', record)"
                      >关闭订单</a-menu-item
                    >
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'INTERVIEW'"
            >
              <a-col
                v-if="
                  record.interviews.length > 0 &&
                    record.interviews[0].status === 'PROCESS'
                "
              >
                <a-button
                  type="link"
                  @click.stop="$refs.checkInterviewModal.show(record)"
                  >标记面试结果</a-button
                >
                <br />
                <a-button
                  type="link"
                  @click.stop="$refs.cancelInterviewModal.show(record)"
                  >取消面试</a-button
                >
              </a-col>
              <a-col v-else>
                <a-button
                  type="link"
                  @click.stop="$refs.arrangeInterviewModal.show(record)"
                  >安排下一轮面试</a-button
                >
                <br />
                <a-button
                  type="link"
                  @click.stop="$refs.offerModal.show(record)"
                  >发送offer</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                    <!-- <a-menu-item
                      v-if="
                        record.interviews.length == 1 &&
                          record.interviews[0].status === 'PROCESS'
                      "
                      @click="stopStep('关闭订单', record)"
                    >关闭订单</a-menu-item>-->
                    <a-menu-item @click="stopStep('关闭订单', record)"
                      >关闭订单</a-menu-item
                    >
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'OFFERED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('已入职', record)"
                  >已入职</a-button
                >
                <br />
                <a-button type="link" @click.stop="stopStep('未入职', record)"
                  >未入职</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'ENTERED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('已过保', record)"
                  >已过保</a-button
                >
                <br />
                <a-button type="link" @click.stop="stopStep('未过保', record)"
                  >未过保</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="center"
              align="middle"
              v-if="status == 'COMPLETED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('归档', record)"
                  >归档</a-button
                >
              </a-col>
              <a-col style="marginRight:15px">
                <a-divider
                  type="vertical"
                  style="margin:0;height:15px;background:#00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="$refs.addCommunicationModal.show(record)"
                      >沟通记录</a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                      >软性点评</a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                      >附件简历</a-menu-item
                    >
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/resume/downloadAttachment?attachment_id=' +
                            record.attachment.id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                        :href="
                          baseUrl +
                            '/post/report/downloadPdfReport?report_id=' +
                            record.resume_report_id +
                            '&token=' +
                            $store.state.token
                        "
                        download
                        >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                      :href="
                        baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                      "
                      download
                      >简历报告(DOC)</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
          </div>
          <div v-else>
            <a-button
              type="link"
              @click.stop="$refs.preview.show(record.attachment)"
              >附件简历</a-button
            >
          </div>
        </template>
      </a-table>
    </div>

    <a-drawer
      :visible="drawer"
      :closable="false"
      width="1000"
      @close="drawer = !drawer"
      :destroyOnClose="true"
    >
      <a-row
        type="flex"
        justify="space-between"
        align="middle"
        style="paddingBottom:40px;"
      >
        <a-col style="cursor:pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
        </a-col>
        <a-col style="cursor:pointer" @click="viewDetail">
          <a-icon type="fullscreen" />在新窗口打开
        </a-col>
      </a-row>
      <order-detail :id="order_id"></order-detail>
    </a-drawer>
    <!-- //modal -->
    <failed-modal ref="failedModal" @ok="getData()"></failed-modal>
    <cancel-interview-modal
      ref="cancelInterviewModal"
      @ok="getData()"
    ></cancel-interview-modal>
    <check-interview-modal
      ref="checkInterviewModal"
      @ok="getData()"
      @cancel="unpassInterview"
    ></check-interview-modal>
    <offer-modal ref="offerModal" @ok="getData()"></offer-modal>
    <add-communication-modal
      ref="addCommunicationModal"
    ></add-communication-modal>
    <arrange-interview-modal
      ref="arrangeInterviewModal"
      @ok="getData()"
    ></arrange-interview-modal>
    <comment-modal ref="commentModal"></comment-modal>
    <resume-preview-modal ref="preview"></resume-preview-modal>

  </div>
</template>

<script>
import Api from "@/api";
import moment from "moment";
import FailedModal from "../../order/failed-modal";
import OrderDetail from "../../order/order-detail";
import CancelInterviewModal from "../../order/cancel-interview-modal";
import CheckInterviewModal from "../../order/check-interview-modal";
import OfferModal from "../../order/offer-modal";
import AddCommunicationModal from "../../order/add-communication-modal";
import ArrangeInterviewModal from "../../order/arrange-interview-modal";
import ResumePreviewModal from "@/components/resume-preview-modal";
import CommentModal from "../../order/comment-modal";
import baseComponentVue from "@/components/base-component.vue";
import { getOrderStatus } from "@/shared/utils/bootstrap";
import debounce from "lodash/debounce";

export default {
  name: 'Candidate',
  extends: baseComponentVue,
  props: {
    job_id: {
      default: -1
    },
  },
  components: {
    FailedModal,
    OrderDetail,
    CancelInterviewModal,
    CheckInterviewModal,
    OfferModal,
    AddCommunicationModal,
    ArrangeInterviewModal,
    CommentModal,
    ResumePreviewModal
  },
  data() {
    return {
      statues: 'CREATED',
      radioData: [
        { label: "新推荐", value: "CREATED" },
        { label: "审核通过", value: "AUDIT_PASSED" },
        { label: "面试中", value: "SUBMIT_PASSED,INTERVIEW" },
        { label: "已Offer", value: "OFFERED" },
        { label: "已入职", value: "ENTERED" },
        { label: "已过保", value: "COMPLETED" },
        { label: "已完成", value: "UNSETTLED,SETTLED" },
        { label: "结束", value: "CLOSED" },
      ],
      order: 'process', //订单菜单类型
      baseUrl: process.env.VUE_APP_BASEURL,
      loading: false,
      dataSource: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      options: [],
      halfPage: false,
      order_id: undefined,
      suggestion: [],
      drawer: false
    }
  },
  created() {
    this.setActionColums()
  },
  mounted() {
    this.getData()
  },
  methods: {
    setActionColums() {
      let columns = [
        // {
        //   title: '做单号',
        //   dataIndex: "id",
        //   width: 100
        // },
        {
          title: "订单号",
          dataIndex: "order_no",
        },
        {
          title: "职位",
          dataIndex: "job_name"
        },
        {
          title: "候选人",
          dataIndex: "resume_name",
          width: 80
        },
        {
          title: "猎头",
          dataIndex: "hunter_name",
          scopedSlots: { customRender: "hunter" }
        },
        {
          width: "138px",
          align: "center",
          title: "订单阶段",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "订单状态",
          dataIndex: "status_text",
          width: 100
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        }
      ];
      if (this.isGranted("post_manager.post_process_list.btn_list_audit")) {
        columns.push({
          align: "center",
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        });
      }
      this.columns = columns;
    },
    async getData(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let params = {
        job_id: this.job_id,
        statuses: this.statues,
        is_company_job: 1,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      try {
        let response = await Api.order.getList(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
      } catch (e) {}
      this.loading = false;
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;
            this.order_id = record.id;
          }
        }
      };
    },
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve({
        path: `/order/detail/${this.order_id}`
      });
      window.open(resolveDRoute.href, "_blank");
    },
    nextStep(text, record) {
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", { style: { paddingTop: "20px" } }, [
          h("p", `确定要将简历标记为"${text}"`),
          h("p", "该操作不可逆，请谨慎操作")
        ]),
        onOk: () => {
          //审核通过
          if (record.status === "CREATED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.audit({ post_id: record.id });
                this.getData();
              } catch (e) {}
              resolve();
            });
          }
          //推荐通过
          if (record.status === "AUDIT_PASSED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.submit({ post_id: record.id });
                this.getData();
              } catch (e) {}
              resolve();
            });
          }
          //入职
          if (record.status === "OFFERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.entered({ post_id: record.id });
                this.getData();
              } catch (e) {}
              resolve();
            });
          }
          //过保
          if (record.status === "ENTERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.completed({ post_id: record.id });
                this.getData();
              } catch (e) {}
              resolve();
            });
          }
          //归档
          if (record.status === "COMPLETED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.done({ post_id: record.id });
                this.getData();
              } catch (e) {}
              resolve();
            });
          }
        }
      });
    },
    stopStep(text, record) {
      let { failedModal } = this.$refs;
      failedModal.title = text;
      failedModal.show(record);
    },
    // 标记面试未通过
    unpassInterview(record) {
      let { failedModal } = this.$refs;
      failedModal.title = "面试未通过";
      failedModal.show(record);
    },
    //IE 搜索建议
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.suggestion = arr;
    },
    downloadResume(record) {
      Api.resume.downloadResume({ attachment_id: record.attachment.id });
    },
    downloadReport(record) {
      Api.resume.downloadReport({ resume_id: record.resume_id });
    }

  },

}
</script>

<style lang="scss" scoped>
.candidate {

  

}
</style>